import axios from 'axios'
import { IUserData } from './Auth0'

export const logout = (): void => {
    const localUser = localStorage.getItem('user_data')
    const user: IUserData = JSON.parse(localUser)
    const token = user.id_token
    const redirect_uri = process.env.REACT_APP_AUTH_REDIRECT_URI

    const translations = localStorage.getItem('translations')

    const keep = localStorage.getItem('Login_data')
    localStorage.clear()
    localStorage.setItem('translations', translations)
    if (keep) {
        localStorage.setItem('Login_data', keep)
    }

    const qParams = [
        `id_token_hint=${token}`,
        `post_logout_redirect_uri=${redirect_uri}`,
        // `state=some random string`,
    ].join('&')

    const logoutURL = `${process.env.REACT_APP_AUTH_AUTHORITY}/oauth2/logout?${qParams}`

    window.location.href = logoutURL

    axios.get(logoutURL).then(() => {
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname
        )
    })
}
